import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import DbInput from "../DB-Components/DbInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderWeightInput',
  props: {
  modelValue: {
    type: Number || String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
  ariainvalid: {
    type: String as () => "false" | "grammar" | "spelling" | "true" | undefined,
    default: "false",
    required: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const inputValue = ref<number | null>(props.modelValue);
const emit = __emit;

const handleInput = (event: HTMLInputElement) => {
  const target = event.target as HTMLInputElement;
  const numericValue = parseFloat(target.value.replace(/\./g, ""));
  inputValue.value = isNaN(numericValue) || !numericValue ? null : numericValue;
  emit("update:modelValue", numericValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DbInput, {
    placeholder: __props.placeholder,
    "model-value": inputValue.value,
    value: inputValue.value,
    onInput: handleInput,
    disabled: __props.disabled,
    ariainvalid: __props.ariainvalid,
    class: "w-full hydrated",
    type: "number"
  }, null, 8, ["placeholder", "model-value", "value", "disabled", "ariainvalid"]))
}
}

})